export default __webpack_public_path__ + "static/media/Screenshot_9.707a5c89.png";